"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactComponents = require("@ui-propulsion/react-components");
var _propTypes = require("prop-types");
var _InfoDetailSection = _interopRequireDefault(require("../InfoDetailSection"));
var _index = require("../../utils/index");
require("./styles.scss");
var ApplicationInfo = function ApplicationInfo(_ref) {
  var firstName = _ref.firstName,
    lastName = _ref.lastName,
    mailingAddress1 = _ref.mailingAddress1,
    mailingAddressCity = _ref.mailingAddressCity,
    mailingAddressState = _ref.mailingAddressState,
    mailingAddressZip = _ref.mailingAddressZip,
    homePhone = _ref.homePhone;
  var ApplicantContact = function ApplicantContact() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, mailingAddress1), /*#__PURE__*/_react.default.createElement("p", null, "".concat(mailingAddressCity, " ").concat(mailingAddressState, " ").concat(mailingAddressZip)), /*#__PURE__*/_react.default.createElement("p", null, (0, _index.formatPhoneNumber)(homePhone)));
  };
  return /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    className: "application-info",
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement("b", {
    className: "refund__section-title"
  }, "APPLICATION INFORMATION"), /*#__PURE__*/_react.default.createElement(_InfoDetailSection.default, {
    label: "Patient(s):",
    detail: "".concat(lastName, ", ").concat(firstName)
  }), /*#__PURE__*/_react.default.createElement(_InfoDetailSection.default, {
    label: "Applicant(s):",
    detail: "".concat(lastName, ", ").concat(firstName)
  }), /*#__PURE__*/_react.default.createElement(_InfoDetailSection.default, {
    label: "Applicant Contact:",
    detail: /*#__PURE__*/_react.default.createElement(ApplicantContact, null)
  })));
};
ApplicationInfo.propTypes = {
  firstName: _propTypes.string.isRequired,
  lastName: _propTypes.string.isRequired,
  mailingAddress1: _propTypes.string.isRequired,
  mailingAddressCity: _propTypes.string.isRequired,
  mailingAddressState: _propTypes.string.isRequired,
  mailingAddressZip: _propTypes.string.isRequired,
  homePhone: _propTypes.string.isRequired
};
var _default = exports.default = ApplicationInfo;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-refunds/lib/components/ApplicationInfo/styles.scss');